module.exports = __webpack_public_path__ + "img/01010402.c2ff119c.png";